module.exports = __webpack_public_path__ + "static/media/chart-icon.0abe1a5a.svg";